import { compact } from '@quromedical/utils';
import type { Field } from 'components/types';
import { pathologyTestFetcher } from 'hooks/usePathology';
import { strings } from 'strings';

import type { PathologyCreateOrderForm } from './types';

export const createFields = (): Field<PathologyCreateOrderForm>[] => {
  const fields: (Field<PathologyCreateOrderForm> | undefined)[] = [
    {
      subfields: [
        {
          key: 'collectionDateTime',
          type: 'date-component',
          label: strings.PathologySampleDateTimeLabel,
          maskType: 'datetime',
        },
      ],
    },
    {
      subfields: [
        {
          key: 'tests',
          type: 'combobox-multiple',
          searchable: true,
          label: strings.PathologyRequestTestsNormalLabel,
          returnFullOption: false,
          fetcher: pathologyTestFetcher(),
        },
      ],
    },
    {
      subfields: [
        {
          key: 'comment',
          type: 'text-box',
          label: strings.PathologyCommentLabel,
          multiline: true,
        },
      ],
    },
  ];

  return compact(fields);
};
